import { decodeUrlParams, queryStringtoSearchFilters } from '../utils/helpers';

const performSearch = (params, search, searchFilters = {}, location) => {
    const values = decodeUrlParams(params);
    const qParams = location.state;

    let urlFilters = qParams?.searchFilters ?
        queryStringtoSearchFilters(decodeURIComponent(qParams.searchFilters)) :
        [];
    if (urlFilters?.find(u => u.id === 'hasEquipment')) {
        urlFilters = urlFilters?.filter(f => f.id !== 'hasEquipment');
    } else {
        urlFilters = [
            ...urlFilters,
            {
                id: 'hasEquipment',
                operator: null,
                prefix: 'installed-at',
                value: 'true',
            },
        ];
    }

    const filters = urlFilters?.map((f) => {
        const filter = searchFilters[values.type]?.filters?.find(s => s.id === f.id);
        const mapping = filter?.valueMapping;
        if (mapping && f.id !== 'hasEquipment') {
            let value = null;
            if (filter.type === 'select') {
                const selectValues = f.value.split(';');
                value = selectValues
                    ?.map(v =>
                        Object.entries(mapping)?.find(([, mappingValue]) => mappingValue === v)[0],
                    )
                    .join(';') ||
                    null;
            } else {
                value = Object.entries(mapping)
                    ?.find(([, mappingValue]) => mappingValue === f.value)[0] ||
                    null;
            }
            return {
                ...f,
                value,
            };
        }
        return f;
    });
    search({ ...values, filters });
};

export default performSearch;
